import WistiaProvider from './providers/wistia';
import { PROVIDER_TYPES } from './constants';

/**
 * Move resizing and setting width, height to wistia(provider)
 * Add abstract class
 * */
class VideoWrapper {
  constructor({
    videoId,
    providerType = PROVIDER_TYPES.WISTIA,
    userId,
    onStoreEvent,
    progressTrackingKey,
    time = 0,
    progressVector,
    isImpersonating,
    isSPP,
  }) {
    this.videoId = videoId;
    this.progressTrackingKey = progressTrackingKey;
    this.userId = userId;
    this.onStoreEvent = onStoreEvent;
    this.isImpersonating = isImpersonating;
    this.isSPP = isSPP;
    this._setupProvider(videoId, providerType, time, progressVector);
  }

  _setupProvider(videoId, providerType, time, progressVector) {
    if (!videoId) {
      throw Error('Empty video id not allowed');
    }

    this.providerType = providerType;
    const videoOptions = {
      progressTrackingKey: this.progressTrackingKey,
      time,
    };

    this.videoProviderHandler = null;
    switch (providerType) {
      case PROVIDER_TYPES.WISTIA:
        this.videoProviderHandler = new WistiaProvider(
          videoId,
          {
            progressVector,
            isImpersonating: this.isImpersonating,
          },
          videoOptions,
        );
        break;
      default:
        throw Error(`Unknown video provider ${providerType} detected`);
    }
  }

  bind(event, callback) {
    this.videoProviderHandler.bind(event, callback);
  }

  unbind(event, callback) {
    this.videoProviderHandler.unbind(event, callback);
  }

  destroy() {
    if (this.videoProviderHandler) {
      this.videoProviderHandler.destroy();
    }
  }

  getProgressData() {
    return this.videoProviderHandler.getInternalData();
  }
}

export default VideoWrapper;
